// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;500;600;700;800;900;1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200&display=swap');*/
/*@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap');*/
/*@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans&display=swap');*/

/*
*
* Start General Style
*
*/

html {
    font-family: 'Nunito', sans-serif;
    font-size: 16px;
}

/*For tables*/
/*.heightTableCalc {*/
/*    width: calc(100vw - 21.4rem);*/
/*}*/

.topTableCalc{
    margin-top: 6.4rem;
}
.bgPurpuleCustom{
    background-color: #30006d;
}

.thead-rounded th:first-child {
    border-top-left-radius: 20px;
}
.th-rounded-top-right{
    border-top-right-radius: 20px;
}
.overflow-auto{
    overflow: auto;
}

body {
    background: white;
    border-radius: 2px;
    color: #717579;
}
.grayed-text {
    color: rgba(0, 0, 0, 0.7);
}

div.Toastify__toast-container--top-right {
    z-index: 100000000000000;

}

.Toastify__toast-theme--light {
    z-index: 100000000000000;

}

input[type="month"] {
    position: relative;
}

input[type="month"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    width: 100%;
    position: absolute;
    height: 100%;
    left: 0;
}

select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

.mr-20 {
    margin-right: 5rem;
}

.pl-0 {
    padding-left: 0 !important;
}

/*
* START SIDE BAR
*/
.top-menu {
    position: fixed;
    top: 0;
    right: 0;
    padding-right: 30px;
    /*width: calc(100% - 21.4rem);*/
    align-items: center;
    /*padding: 30px 10px;*/
    z-index: 9999;
}

.top-menu .account {
    /* width: 230px; */
}


.side-menu .logo {
    margin: 1.5rem;
    height: 70px;
    width: 310px;
}

.side-menu {
    top: 0;
    left: 0;
    /*border-right: 2px solid #EEEEEE;*/
}

.side-menu .close-btn {
    text-align: center;
    padding-bottom: 22px;
    display: none;
}

.side-menu .close-btn svg {
    text-align: center;
    border: 1px solid;
    padding: 0px;
    font-size: 38px;
    border-radius: 50%;
    cursor: pointer;
}

.side-menu > svg {
    font-size: 2.7rem;
}

.toggle-side-bar {
    transform: translateX(0) !important;
}

.side-menu .input-field,
.search-pop-up .input-field {
    width: 280px;
    /*margin: 0 auto;*/
    /*margin-bottom: 20px;*/
}


.side-menu .input-field input,
.search-pop-up .input-field input,
.side-menu .input-field select {
    /*height: 43px;*/
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    border-radius: 10px;
    padding-left: 15px;
    width: 100%;
}

.side-menu .input-field > svg,
.search-pop-up .input-field > svg {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
}

.pick-input .input-field {
    /*margin-top: 10px;*/
}

.pick-input svg:first-child {
    font-size: 32px;
}

.pick-input h4 {
    margin-left: 7px;
    align-self: center;
    font-style: normal;
    /*font-weight: 600;*/
    line-height: 23px;
}

.pick-input form {
    /* margin-left: 4px !important; */
}

.side-bar-link {
    margin-bottom: 30px;
    height: 40px;
}

.side-bar-link > div {
    align-self: center;
}

.side-bar-link svg {
    font-size: 32px;
    align-self: center;
}

/*
* Content Style
*/
.placeholder-connexion::placeholder {
    color: #5a45aa;
    font-weight: normal;
}


.arrow-rotate-right {
    transform: rotate(180deg);
}

.arrow-rotate-right > div > svg, .arrow-rotate-left > div > svg {
    font-size: 15px;
}

.arrow-rotate-right > div > svg:last-of-type, .arrow-rotate-left > div > svg:last-of-type {
    color: #bfc9ce;
}

.bg-grisbleu {
    background-color: #F2F5FF;
}

.bg-bleuPale {
    background-color: #f2ffff;
}

.bg-rosePale {
    background-color: #fff3fb;
}

.bg-roseTable {
    background-color: #c2027d !important;
}

.bg-orangeTable {
    background-color: #ff8a1f !important;
}

.bg-bleuTable {
    background-color: #10c5c5 !important;
}

#connect-page > div:first-of-type {
    height: 100%;
}

.dates-filtre svg {
    font-size: 1rem !important;
    margin-right: 0.5rem;
}
svg.custom-calendar-icon {
    font-size: 1.4rem !important;
    margin-right: -5px !important
}


.content {
    /*width: calc(100% - 21.4rem);*/
    margin-top: 6.4rem;
    background-color: white;
    padding-left: 3.3rem;
    padding-right: 25px;
    padding-bottom: 60px;
}

.content-table {
    padding-left: 367px;
    /*width: calc(100% - 343px);*/
    /*padding-left: 25px;*/
    /*margin-left: 342px;*/
    background-color: white;

    padding-right: 25px;
}

.content-table-mobile {
    width: 100%;
    background-color: white;
    padding-left: 25px;
    padding-right: 25px;
}


.mobile-navbar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #5A45AA;
    z-index: 999999;
    text-align: center;
    display: none;
}


.mobile-navbar .btn {
    height: 100%;
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
}

.mobile-navbar .btn a {
    display: block;
    flex: 1 1;
    color: white;
}

.mobile-navbar .btn a svg {
    font-size: 30px;
    cursor: pointer;
}

@media (max-width: 1600px) {

    .top-menu {
        /*width: calc(100% - 16rem);*/
    }

    /*.heightTableCalc {*/
    /*    width: calc(100vw - 16rem);*/
    /*}*/

    .content {
        /*width: calc(100% - 16rem);*/
        /*margin-left: 16rem;*/
    }

    .side-menu .logo {
        width: calc(100% - 20px);
        margin: 10px auto 20px auto;
        height: auto;
    }

    .md-device-bar {
        width: 16rem;
    }

    .side-menu .input-field,
    .search-pop-up .input-field {
        margin-left: 10px;
        margin-right: 10px;
        width: calc(100% - 20px);
    }
}

@media (max-width: 1000px) {

    .mobile-navbar {
        display: block;
    }

    .top-menu {
        width: 100%;
        border-bottom: 1px solid darkgray;
    }

    .top-menu .account {
        display: none;
    }

    .side-menu {
        /*transform: translateX(-100%);*/
        /*width: 100%;*/
        /*height: 100%;*/
        /*overflow-y: auto;*/
    }

    .side-menu .close-btn {
        display: block !important;
    }

    .content {
        width: 100%;
        margin-left: 0;
    }
}


/* Messages */
.notification-container {
    width: 100%;
    position: relative;
}

.notification-container img {
    cursor: pointer;
}

.notification-badge {
    position: absolute;
    top: -16px;
    right: -11px;
    color: white;
    border-radius: 100%;
    height: 28px;
    width: 28px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
}

/* Static Pages content */
.nav-link {
    text-decoration: underline;
    color: black;
    display: inline-block; 
}

.page-content {
    height: auto !important;
    padding: 5rem 2rem;
}

.page-content p {
    text-align: justify;
}

.page-content ul {
    list-style: none;
}

.page-content ul li {
    position: relative;
    padding-left: 30px;
    margin: 0.75rem 0;
}

.page-content ul li::before {
    content: "––";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 10px;
    text-align: center;
    color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/main.css"],"names":[],"mappings":"AAEA,6FAA6F;AAC7F,yFAAyF;AACzF,oFAAoF;;AAEpF;;;;CAIC;;AAED;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA,aAAa;AACb,qBAAqB;AACrB,oCAAoC;AACpC,IAAI;;AAEJ;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;CAEC;AACD;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;;AAGA;;;IAGI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;CAEC;AACD;IACI,cAAc;IACd,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;AACA;IACI,4BAA4B;IAC5B;AACJ;;;AAGA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,SAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI;QACI,6BAA6B;IACjC;;IAEA,qBAAqB;IACrB,kCAAkC;IAClC,IAAI;;IAEJ;QACI,6BAA6B;QAC7B,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;;QAEI,iBAAiB;QACjB,kBAAkB;QAClB,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,iCAAiC;IACrC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;QAChC,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;AACJ;;;AAGA,aAAa;AACb;IACI,WAAW;IAGX,kBAAkB;AAFtB;;AAKA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;500;600;700;800;900;1000&display=swap');\n\n/*@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200&display=swap');*/\n/*@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap');*/\n/*@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans&display=swap');*/\n\n/*\n*\n* Start General Style\n*\n*/\n\nhtml {\n    font-family: 'Nunito', sans-serif;\n    font-size: 16px;\n}\n\n/*For tables*/\n/*.heightTableCalc {*/\n/*    width: calc(100vw - 21.4rem);*/\n/*}*/\n\n.topTableCalc{\n    margin-top: 6.4rem;\n}\n.bgPurpuleCustom{\n    background-color: #30006d;\n}\n\n.thead-rounded th:first-child {\n    border-top-left-radius: 20px;\n}\n.th-rounded-top-right{\n    border-top-right-radius: 20px;\n}\n.overflow-auto{\n    overflow: auto;\n}\n\nbody {\n    background: white;\n    border-radius: 2px;\n    color: #717579;\n}\n.grayed-text {\n    color: rgba(0, 0, 0, 0.7);\n}\n\ndiv.Toastify__toast-container--top-right {\n    z-index: 100000000000000;\n\n}\n\n.Toastify__toast-theme--light {\n    z-index: 100000000000000;\n\n}\n\ninput[type=\"month\"] {\n    position: relative;\n}\n\ninput[type=\"month\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    left: 0;\n}\n\nselect {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n}\n\n.mr-20 {\n    margin-right: 5rem;\n}\n\n.pl-0 {\n    padding-left: 0 !important;\n}\n\n/*\n* START SIDE BAR\n*/\n.top-menu {\n    position: fixed;\n    top: 0;\n    right: 0;\n    padding-right: 30px;\n    /*width: calc(100% - 21.4rem);*/\n    align-items: center;\n    /*padding: 30px 10px;*/\n    z-index: 9999;\n}\n\n.top-menu .account {\n    /* width: 230px; */\n}\n\n\n.side-menu .logo {\n    margin: 1.5rem;\n    height: 70px;\n    width: 310px;\n}\n\n.side-menu {\n    top: 0;\n    left: 0;\n    /*border-right: 2px solid #EEEEEE;*/\n}\n\n.side-menu .close-btn {\n    text-align: center;\n    padding-bottom: 22px;\n    display: none;\n}\n\n.side-menu .close-btn svg {\n    text-align: center;\n    border: 1px solid;\n    padding: 0px;\n    font-size: 38px;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.side-menu > svg {\n    font-size: 2.7rem;\n}\n\n.toggle-side-bar {\n    transform: translateX(0) !important;\n}\n\n.side-menu .input-field,\n.search-pop-up .input-field {\n    width: 280px;\n    /*margin: 0 auto;*/\n    /*margin-bottom: 20px;*/\n}\n\n\n.side-menu .input-field input,\n.search-pop-up .input-field input,\n.side-menu .input-field select {\n    /*height: 43px;*/\n    background: #FFFFFF;\n    border: 1px solid #EEEEEE;\n    box-sizing: border-box;\n    border-radius: 10px;\n    padding-left: 15px;\n    width: 100%;\n}\n\n.side-menu .input-field > svg,\n.search-pop-up .input-field > svg {\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.pick-input .input-field {\n    /*margin-top: 10px;*/\n}\n\n.pick-input svg:first-child {\n    font-size: 32px;\n}\n\n.pick-input h4 {\n    margin-left: 7px;\n    align-self: center;\n    font-style: normal;\n    /*font-weight: 600;*/\n    line-height: 23px;\n}\n\n.pick-input form {\n    /* margin-left: 4px !important; */\n}\n\n.side-bar-link {\n    margin-bottom: 30px;\n    height: 40px;\n}\n\n.side-bar-link > div {\n    align-self: center;\n}\n\n.side-bar-link svg {\n    font-size: 32px;\n    align-self: center;\n}\n\n/*\n* Content Style\n*/\n.placeholder-connexion::placeholder {\n    color: #5a45aa;\n    font-weight: normal;\n}\n\n\n.arrow-rotate-right {\n    transform: rotate(180deg);\n}\n\n.arrow-rotate-right > div > svg, .arrow-rotate-left > div > svg {\n    font-size: 15px;\n}\n\n.arrow-rotate-right > div > svg:last-of-type, .arrow-rotate-left > div > svg:last-of-type {\n    color: #bfc9ce;\n}\n\n.bg-grisbleu {\n    background-color: #F2F5FF;\n}\n\n.bg-bleuPale {\n    background-color: #f2ffff;\n}\n\n.bg-rosePale {\n    background-color: #fff3fb;\n}\n\n.bg-roseTable {\n    background-color: #c2027d !important;\n}\n\n.bg-orangeTable {\n    background-color: #ff8a1f !important;\n}\n\n.bg-bleuTable {\n    background-color: #10c5c5 !important;\n}\n\n#connect-page > div:first-of-type {\n    height: 100%;\n}\n\n.dates-filtre svg {\n    font-size: 1rem !important;\n    margin-right: 0.5rem;\n}\nsvg.custom-calendar-icon {\n    font-size: 1.4rem !important;\n    margin-right: -5px !important\n}\n\n\n.content {\n    /*width: calc(100% - 21.4rem);*/\n    margin-top: 6.4rem;\n    background-color: white;\n    padding-left: 3.3rem;\n    padding-right: 25px;\n    padding-bottom: 60px;\n}\n\n.content-table {\n    padding-left: 367px;\n    /*width: calc(100% - 343px);*/\n    /*padding-left: 25px;*/\n    /*margin-left: 342px;*/\n    background-color: white;\n\n    padding-right: 25px;\n}\n\n.content-table-mobile {\n    width: 100%;\n    background-color: white;\n    padding-left: 25px;\n    padding-right: 25px;\n}\n\n\n.mobile-navbar {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 60px;\n    background: #5A45AA;\n    z-index: 999999;\n    text-align: center;\n    display: none;\n}\n\n\n.mobile-navbar .btn {\n    height: 100%;\n    display: flex;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: center;\n}\n\n.mobile-navbar .btn a {\n    display: block;\n    flex: 1 1 0px;\n    color: white;\n}\n\n.mobile-navbar .btn a svg {\n    font-size: 30px;\n    cursor: pointer;\n}\n\n@media (max-width: 1600px) {\n\n    .top-menu {\n        /*width: calc(100% - 16rem);*/\n    }\n\n    /*.heightTableCalc {*/\n    /*    width: calc(100vw - 16rem);*/\n    /*}*/\n\n    .content {\n        /*width: calc(100% - 16rem);*/\n        /*margin-left: 16rem;*/\n    }\n\n    .side-menu .logo {\n        width: calc(100% - 20px);\n        margin: 10px auto 20px auto;\n        height: auto;\n    }\n\n    .md-device-bar {\n        width: 16rem;\n    }\n\n    .side-menu .input-field,\n    .search-pop-up .input-field {\n        margin-left: 10px;\n        margin-right: 10px;\n        width: calc(100% - 20px);\n    }\n}\n\n@media (max-width: 1000px) {\n\n    .mobile-navbar {\n        display: block;\n    }\n\n    .top-menu {\n        width: 100%;\n        border-bottom: 1px solid darkgray;\n    }\n\n    .top-menu .account {\n        display: none;\n    }\n\n    .side-menu {\n        /*transform: translateX(-100%);*/\n        /*width: 100%;*/\n        /*height: 100%;*/\n        /*overflow-y: auto;*/\n    }\n\n    .side-menu .close-btn {\n        display: block !important;\n    }\n\n    .content {\n        width: 100%;\n        margin-left: 0;\n    }\n}\n\n\n/* Messages */\n.notification-container {\n    width: 100%;\n}\n.notification-container {\n    position: relative;\n}\n\n.notification-container img {\n    cursor: pointer;\n}\n\n.notification-badge {\n    position: absolute;\n    top: -16px;\n    right: -11px;\n    color: white;\n    border-radius: 100%;\n    height: 28px;\n    width: 28px;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid white;\n}\n\n/* Static Pages content */\n.nav-link {\n    text-decoration: underline;\n    color: black;\n    display: inline-block; \n}\n\n.page-content {\n    height: auto !important;\n    padding: 5rem 2rem;\n}\n\n.page-content p {\n    text-align: justify;\n}\n\n.page-content ul {\n    list-style: none;\n}\n\n.page-content ul li {\n    position: relative;\n    padding-left: 30px;\n    margin: 0.75rem 0;\n}\n\n.page-content ul li::before {\n    content: \"––\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 10px;\n    text-align: center;\n    color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
